<template>
  <div class="main-wrapper">
    <div>
      <!-- <layout-header2></layout-header2> -->
      <layout-header></layout-header>
      <breadcrumb7></breadcrumb7>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar></sidebar>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
              <loader></loader>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-else>
              <!-- <div>
                <h3 class="mb-3 mt-2">Social Media</h3>
              </div> -->
              <div class="card ml-md-4">
                <div class="card-body">
                  <!-- Social Form -->
                  <!-- <form> -->
                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-xl-6">
                      <div class="form-group">
                          <label> <i class="fab fa-facebook" style="color:#4867aa;"></i> Facebook </label>
                        <input
                          type="url"
                          v-model="doctor_social_profile.facebook"
                          class="form-control"
                           @input="restrictToUrl('facebook')"
                          placeholder="Enter a valid URL (e.g., https://www.example.com)"
                        />
                        <span v-if="errors.facebook" class="text-danger">{{ errors.facebook }}</span>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-xl-6">
                      <div class="form-group">
                       <label> <i class="fab fa-twitter" style="color:#1da1f2;"></i> X (Formerly Twitter) </label>
                        <input
                          type="url"
                          v-model="doctor_social_profile.twitter"
                          class="form-control"
                          @input="restrictToUrl('twitter')"
                          placeholder="Enter a valid URL (e.g., https://www.example.com)"
                        />
                        <span v-if="errors.twitter" class="text-danger">{{ errors.twitter }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-xl-6">
                      <div class="form-group">
                        <i class="fab fa-instagram" style="color: #f500a7;"></i> Instagram
                        <input
                          type="url"
                          v-model="doctor_social_profile.instagram"
                          class="form-control mt-2"
                          @input="restrictToUrl('instagram')"
                          placeholder="Enter a valid URL (e.g., https://www.example.com)"
                        />
                        <span v-if="errors.instagram" class="text-danger">{{ errors.instagram }}</span>
                        
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-xl-6">
                      <div class="form-group">
                       <label>
                          <i class="fab fa-pinterest" style="color: #b7081b;"></i> Pinterest
                        </label>
                        <input
                          type="url"
                          v-model="doctor_social_profile.pinterest"
                          class="form-control"
                          @input="restrictToUrl('pinterest')"
                          placeholder="Enter a valid URL (e.g., https://www.example.com)"
                        />
                        <span v-if="errors.pinterest" class="text-danger">{{ errors.pinterest }}</span>
                        
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-xl-6">
                      <div class="form-group">
                       <label>  <i class="fab fa-linkedin" style="color: #0077b5;"></i> LinkedIn </label>
                        <input
                          type="url"
                          v-model="doctor_social_profile.linkedin"
                          class="form-control"
                          @input="restrictToUrl('linkedin')"
                          placeholder="Enter a valid URL (e.g., https://www.example.com)"
                        />
                        <span v-if="errors.linkedin" class="text-danger">{{ errors.linkedin }}</span>
                        
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-xl-6">
                      <div class="form-group">
                       <label> <i class="fab fa-youtube" style="color: #fe0000;"></i> YouTube</label>
                        <input
                          type="url"
                          v-model="doctor_social_profile.youtube"
                          class="form-control"
                          @input="restrictToUrl('youtube')"
                          placeholder="Enter a valid URL (e.g., https://www.example.com)"
                        />
                        <span v-if="errors.youtube" class="text-danger">{{ errors.youtube }}</span>
                        
                      </div>
                    </div>
                  </div>
                  <div class="submit-section text-left justify-content-start">
                    <button
                      type="submit"
                      @click="Save_Information()"
                      class="btn btn-primary submit-btn"
                    >
                      Save Changes
                    </button>
                  </div>
                  <!-- </form> -->
                  <!-- /Social Form -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CommonApi from "../../../services/CommonApi";
export default {
  data() {
    return {
      doctor_social_profile: {
        facebook: '',
        twitter: '',
        linkedin: '',
        instagram: '',
        youtube: '',
        pinterest: '',
      },
      showspinner: true,
      errors: {},
    };
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }
    this.get_doctor_social_profile();
  },
  methods: {

    restrictToUrl(field) {
    const strictUrlRegex = /^(https?:\/\/)(www\.)?([\w\-]+\.)+[a-z]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;%=]*)?$/i;
    const value = this.doctor_social_profile[field];
    if (value && !strictUrlRegex.test(value)) {
      this.$set(this.errors, field, "Invalid URL in " + field + " field.");
    } else {
      this.$set(this.errors, field, ""); // Clear the error if valid
    }
  },

    /* Get Doctor Social Profile  */
    async get_doctor_social_profile() {
      const params = new URLSearchParams();
      params.append("name", this.user_id);
      await CommonApi.get_data(
        "sahaj.api.get_doctor_social_profile",
        params
      ).then((res) => {
        this.showspinner = false;
        this.doctor_social_profile = res.data[0];
      });
    },

    /* Save Doctor Informations */
    Save_Information() {
  // Regex for validating URLs
  const urlRegex = /^(https?:\/\/)?([\w\-]+(\.[\w\-]+)+)(\/[\w\-._~:\/?#[\]@!$&'()*+,;%=]*)?$/;

  // Fields to validate and errors object
  const fieldsToValidate = ['facebook', 'twitter', 'linkedin', 'instagram', 'youtube', 'pinterest'];
  let isValid = true; // Overall form validity

  // Validate each field and set error messages
  fieldsToValidate.forEach((field) => {
    const value = this.doctor_social_profile[field];
    if (value && !urlRegex.test(value)) {
      this.$set(this.errors, field, `Invalid URL in ${field} field.`);
      isValid = false; // Mark form as invalid
    } else {
      this.$set(this.errors, field, ''); // Clear the error if valid
    }
  });

  // If form is invalid, stop execution
  if (!isValid) {
    return;
  }

  // Data to send
  let data = {
    name: this.doctor_social_profile.name,
    facebook: this.doctor_social_profile.facebook,
    twitter: this.doctor_social_profile.twitter,
    linkedin: this.doctor_social_profile.linkedin,
    instagram: this.doctor_social_profile.instagram,
    youtube: this.doctor_social_profile.youtube,
    pinterest: this.doctor_social_profile.pinterest,
  };

  // API Call
  CommonApi.post_data("sahaj.api.update_doctor_social_profile", data).then(
    (res) => {
      if (res && res.status_code === 200) {
        this.$swal.fire({
          icon: "success",
          title: "Success",
          text: res.message,
          showConfirmButton: true,
        });
        this.get_doctor_social_profile();
      } else {
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: res.message,
          showConfirmButton: true,
        });
      }
    }
  );
}
  },
};
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/SocialMedia.vue